import React from 'react';
import PropTypes from 'prop-types';
import * as Validation from './validation';

class BotInputControl extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value: ''
        };
    }

    onChange(e) {
        this.validateField(e.target.value);
    }

    validateField(value) {
        const validation = this.validate(value);

        if (validation && validation.isValidValue) {
            this.setState({
                value: value
            });

            this.props.onChange(value, validation.isValidLength);
        }
    }

    onClick() {
        if (this.props.onClick) {
            this.props.onClick();
        }
        this.validateField(this.state.value);
    }

    validate(value) {
        const validation = Validation.getValidator(this.props.validationType);

        if (!validation) {
            return { isValidValue: true, isValidLength: true };
        }

        return validation.validate(value, this.props.validationType);
    }

    render() {
        return (
            <div>
                {this.props.type == 'radio' ? (
                    <label onClick={() => (this.props.enabled ? this.onClick() : null)}>
                        <input
                            id={this.props.id}
                            disabled={!this.props.enabled}
                            name={this.props.name ? this.props.name : ''}
                            type={this.props.type}
                            value={this.state.value}
                            defaultChecked={this.props.checked}
                            autoComplete="off"
                        />
                        {this.props.label ? <span>{this.props.label}</span> : null}
                    </label>
                ) : this.props.type == 'text' ? (
                    <input
                        id={this.props.id}
                        className="inp"
                        disabled={!this.props.enabled}
                        type={this.props.type}
                        onChange={e => this.onChange(e)}
                        onClick={() => {
                            this.onClick();
                        }}
                        value={this.state.value}
                        autoComplete="off"
                    />
                ) : null}
            </div>
        );
    }
}

BotInputControl.defaultProps = {
    id: '',
    type: 'text',
    name: '',
    text: '',
    enabled: false,
    onChange: () => {}
};

BotInputControl.propTypes = {
    id: PropTypes.string,
    type: PropTypes.string,
    name: PropTypes.string,
    text: PropTypes.string,
    enabled: PropTypes.bool,
    onChange: PropTypes.func
};

export default BotInputControl;
